
// Affiliate Partner Tracking

(function() {
  // 1. Konfiguration
  const urlParams = new URLSearchParams(window.location.search);
  const refValue = urlParams.get('partner');

  if (refValue) {
    // 2. Den Wert im SessionStorage speichern (bleibt aktiv solange der Tab offen ist)
    sessionStorage.setItem('partner', refValue);
  }

  // 3. Den gespeicherten Wert an den Warenkorb übergeben
  const savedRef = sessionStorage.getItem('partner');
  if (savedRef) {
    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: {
          'Partner': savedRef
        }
      })
    })
    .then(response => response.json())
    .catch(error => console.error('Fehler beim Setzen des Attributs:', error));
  }
})();